import $ from 'jquery';

export const showMoreButton = () => {
    $('.pagination').hide();
    $('.show-more-materials-btn').show();
    $('.show-more-btn').show();
};
